import {
  GET_ANNOUNCEMENT_REFERENCE_ASSIGNMENTS_USE_CASE,
  GET_ANNOUNCEMENT_REFERENCE_ASSIGNMENT_USE_CASE,
  GetAssignmentsUseCase,
  GetAssignmentByIdUseCase,
  ASSIGNMENT_REPOSITORY,
  IAssignmentRepository,
} from '@module/assignment';
import {
  CLASS_ANNOUNCEMENT_REPOSITORY,
  IClassAnnouncementRepository,
  GET_CLASS_ANNOUNCEMENTS_USE_CASE,
  GetClassAnnouncementsUseCase,
  GET_CLASS_ANNOUNCEMENT_USE_CASE,
  GetClassAnnouncementUseCase,
  CREATE_CLASS_ANNOUNCEMENT_USE_CASE,
  CreateClassAnnouncementUseCase,
  UPDATE_CLASS_ANNOUNCEMENT_USE_CASE,
  UpdateClassAnnouncementUseCase,
  PIN_CLASS_ANNOUNCEMENT_USE_CASE,
  PinClassAnnouncementUseCase,
  DELETE_CLASS_ANNOUNCEMENT_USE_CASE,
  DeleteClassAnnouncementUseCase,
} from '@module/class';
import { IUserRepository, USER_REPOSITORY } from '@module/user';
import {
  GET_CLASS_TEACHER_OVERVIEW_USE_CASE,
  LIST_CLASS_STUDENT_SUBMISSIONS_USE_CASE,
  GetClassTeacherOverviewUseCase,
  ListClassStudentSubmissionsUseCase,
} from '@module/class';
import {
  CLASS_REPOSITORY,
  LIST_ASSIGNMENT_CLASSES_USE_CASE,
  CREATE_CLASS_USE_CASE,
  GET_CLASS_USE_CASE,
  LIST_CLASS_STUDENTS_USE_CASE,
  LIST_CLASS_TEACHERS_USE_CASE,
  REMOVE_CLASS_STUDENT_USE_CASE,
  REMOVE_CLASS_TEACHER_USE_CASE,
  GET_CLASS_INVITATION_USE_CASE,
  GET_CLASS_INVITATION_BY_CODE_USE_CASE,
  JOIN_CLASS_AS_TEACHER_USE_CASE,
  LEAVE_CLASS_USE_CASE,
  UPDATE_CLASS_USE_CASE,
  ARCHIVE_CLASS_USE_CASE,
  ACTIVATE_CLASS_USE_CASE,
  ActivateClassUseCase,
  DELETE_CLASS_USE_CASE,
  DeleteClassUseCase,
  ArchiveClassUseCase,
  CreateClassUseCase,
  GetClassUseCase,
  IClassRepository,
  ListClassStudentsUseCase,
  ListClassTeachersUseCase,
  LIST_CLASSES_USE_CASE,
  ListClassesUseCase,
  UpdateClassUseCase,
  RemoveClassStudentUseCase,
  RemoveClassTeacherUseCase,
  GetClassInvitationUseCase,
  GetClassInvitationByCodeUseCase,
  JoinClassAsTeacherUseCase,
  LeaveClassUseCase,
  CLASS_STUDENT_PROGRESS_REPOSITORY,
  IClassStudentProgressRepository,
  GET_CLASS_STUDENT_USE_CASE,
  GET_CLASS_STUDENT_OVERVIEW_USE_CASE,
  LIST_CLASS_STUDENT_ASSIGNMENTS_USE_CASE,
  GetClassStudentUseCase,
  GetClassStudentOverviewUseCase,
  ListClassStudentAssignmentsUseCase,
} from '@module/class';

export const classUseCaseProviders = [
  {
    provide: GET_ANNOUNCEMENT_REFERENCE_ASSIGNMENTS_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new GetAssignmentsUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_ANNOUNCEMENT_REFERENCE_ASSIGNMENT_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new GetAssignmentByIdUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },

  {
    provide: GET_CLASS_ANNOUNCEMENTS_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new GetClassAnnouncementsUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: GET_CLASS_ANNOUNCEMENT_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new GetClassAnnouncementUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: CREATE_CLASS_ANNOUNCEMENT_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new CreateClassAnnouncementUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: UPDATE_CLASS_ANNOUNCEMENT_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new UpdateClassAnnouncementUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: PIN_CLASS_ANNOUNCEMENT_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new PinClassAnnouncementUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: DELETE_CLASS_ANNOUNCEMENT_USE_CASE,
    useFactory: (repository: IClassAnnouncementRepository) =>
      new DeleteClassAnnouncementUseCase(repository),
    inject: [CLASS_ANNOUNCEMENT_REPOSITORY],
  },
  {
    provide: GET_CLASS_TEACHER_OVERVIEW_USE_CASE,
    useFactory: (r: IClassStudentProgressRepository) => new GetClassTeacherOverviewUseCase(r),
    inject: [CLASS_STUDENT_PROGRESS_REPOSITORY],
  },
  {
    provide: LIST_CLASS_STUDENT_SUBMISSIONS_USE_CASE,
    useFactory: (r: IClassStudentProgressRepository) => new ListClassStudentSubmissionsUseCase(r),
    inject: [CLASS_STUDENT_PROGRESS_REPOSITORY],
  },
  {
    provide: ACTIVATE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new ActivateClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: DELETE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new DeleteClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: GET_CLASS_STUDENT_USE_CASE,
    useFactory: (repository: IClassStudentProgressRepository) =>
      new GetClassStudentUseCase(repository),
    inject: [CLASS_STUDENT_PROGRESS_REPOSITORY],
  },
  {
    provide: GET_CLASS_STUDENT_OVERVIEW_USE_CASE,
    useFactory: (repository: IClassStudentProgressRepository) =>
      new GetClassStudentOverviewUseCase(repository),
    inject: [CLASS_STUDENT_PROGRESS_REPOSITORY],
  },
  {
    provide: LIST_CLASS_STUDENT_ASSIGNMENTS_USE_CASE,
    useFactory: (repository: IClassStudentProgressRepository) =>
      new ListClassStudentAssignmentsUseCase(repository),
    inject: [CLASS_STUDENT_PROGRESS_REPOSITORY],
  },
  {
    provide: LIST_ASSIGNMENT_CLASSES_USE_CASE,
    useFactory: (repository: IClassRepository) => new ListClassesUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: LIST_CLASSES_USE_CASE,
    useFactory: (repository: IClassRepository) => new ListClassesUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: CREATE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new CreateClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: GET_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new GetClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: LIST_CLASS_TEACHERS_USE_CASE,
    useFactory: (repository: IClassRepository, users: IUserRepository) =>
      new ListClassTeachersUseCase(repository, users),
    inject: [CLASS_REPOSITORY, USER_REPOSITORY],
  },
  {
    provide: LIST_CLASS_STUDENTS_USE_CASE,
    useFactory: (repository: IClassRepository, users: IUserRepository) =>
      new ListClassStudentsUseCase(repository, users),
    inject: [CLASS_REPOSITORY, USER_REPOSITORY],
  },
  {
    provide: UPDATE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new UpdateClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: ARCHIVE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new ArchiveClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: REMOVE_CLASS_TEACHER_USE_CASE,
    useFactory: (repository: IClassRepository) => new RemoveClassTeacherUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: REMOVE_CLASS_STUDENT_USE_CASE,
    useFactory: (repository: IClassRepository) => new RemoveClassStudentUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: GET_CLASS_INVITATION_BY_CODE_USE_CASE,
    useFactory: (repository: IClassRepository) => new GetClassInvitationByCodeUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: GET_CLASS_INVITATION_USE_CASE,
    useFactory: (repository: IClassRepository) => new GetClassInvitationUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: JOIN_CLASS_AS_TEACHER_USE_CASE,
    useFactory: (repository: IClassRepository) => new JoinClassAsTeacherUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
  {
    provide: LEAVE_CLASS_USE_CASE,
    useFactory: (repository: IClassRepository) => new LeaveClassUseCase(repository),
    inject: [CLASS_REPOSITORY],
  },
];
